// Base de API según el módulo activo: el Control de Renovaciones de
// "Riesgos de Personas" usa su propio scope de datos en el backend.
export const crApi = () =>
  window.location.pathname.startsWith("/riesgos-personas") ? "/api/riesgos-personas" : "/api";

export const crEsPersonas = () => window.location.pathname.startsWith("/riesgos-personas");
